import styled from 'styled-components';

export const InputPreHomeStyle = styled.input`
  height: 30px;
  padding: 10px;
  width: calc(100% - 20px);
  border: 1px solid #b6b7ba;
  border-radius: 10px 0px 0px 10px;
`;
